import React from 'react';
import FileInput from './FileInput';
import { connect } from 'react-redux';

import {
  setImageElementFileInfo,
  setImageElementURL,
  setImageElementWidth,
  setImageElementHeight,
  setImageElementAlign,
} from '../actions/image-element-actions';

export const ImageElementOptions = ({
  onFileInfoChange,
  onURLChange,
  onWidthChange,
  onHeightChange,
  onAlignChange,
  options = {},
}) => {
  const { fileInfo = {}, url, width, height, align } = options;

  const handleURLChange = e => onURLChange(e.target.value);
  const handleWidthChange = e => onWidthChange(e.target.value);
  const handleHeightChange = e => onHeightChange(e.target.value);
  const handleAlignChange = e => onAlignChange(e.target.value);

  const onFileClick = fileInfo => {
  };

  return (
    <div>
      <header>Image file:</header>
      <FileInput
        fileInfo={fileInfo}
        format="dataURL"
        accept="image/*"
        onChange={onFileInfoChange}
        onFileClick={onFileClick} />

      <header>Width:</header>
      <input type="text" value={width} onChange={handleWidthChange} />

      <header>Height:</header>
      <input type="text" value={height} onChange={handleHeightChange} />

      <header>Align:</header>
      <select value={align} onChange={handleAlignChange}>
        <option value="left">Left</option>
        <option value="right">Right</option>
        <option value="center">Center</option>
      </select>

      <header>URL:</header>
      <input type="text" value={url} onChange={handleURLChange} />
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { device, id } = ownProps;

  return {
    onFileInfoChange(value) {
      dispatch(setImageElementFileInfo({ device, id, value }));
    },

    onURLChange(value) {
      dispatch(setImageElementURL({ device, id, value }));
    },

    onWidthChange(value) {
      dispatch(setImageElementWidth({ device, id, value }));
    },

    onHeightChange(value) {
      dispatch(setImageElementHeight({ device, id, value }));
    },

    onAlignChange(value) {
      dispatch(setImageElementAlign({ device, id, value }));
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(ImageElementOptions);



// WEBPACK FOOTER //
// ./app/header-builder/components/ImageElementOptions.js